import React from 'react';
import styled from 'styled-components';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { remove, findIndex, forEach, find } from 'lodash';
import {isMobileOnly} from 'react-device-detect';
import ReqFormBrListItem from './ReqFormBrListItem';
import AnimateHeight from 'react-animate-height';
import * as F from '../../lib/util/CommonFunctions';
import CurrencyInputComp from '../common/input/CurrencyInputComp';

const ReqFormBrListBlock = styled.div`

`;

const ReqFormBrListHeaderBlock = styled.div`
    ${isMobileOnly?`
    height: 60px; 
    `:`
    height: 70px;
    border-top: 2px solid #111111;
    `};

    position: relative;
    
    padding: 20px 0px;
`;

const ReqFormBrListHeaderBrandBlock = styled.div`
    ${isMobileOnly?`
    float: left;
    line-height: 24px;
    margin-right: 10px;
    font-size: 16px;
    `:`
    float: left;
    line-height: 30px;
    margin-left: 36px;
    margin-right: 10px;
    font-size: 18px;
    `};

    font-weight: 500;
    color: #333333;
    
`;

const ReqFormBrListHeaderNumBlock = styled.span`
    ${isMobileOnly?`
    font-size: 14px; 
    margin-top: 1px;  
    `:`
    font-size: 16px;
    line-height: 30px;
    `};
    
    font-weight: 500;
    float: left;
    
    color: #111111;
`;

const ReqFormBrListHeaderArrowSpanBlock = styled.span`
    ${isMobileOnly?`
    padding-top: 0px;
    padding-bottom: 20px;
    width: 17px; 
    `:`
    padding-top: 8px;
    padding-bottom: 20px;
    width: 60px;
    `};

    float: right;
    
    //height: 70px;
    background: url(/assets/images/icon/da-icon.png) center center/auto no-repeat;

    &.active {
        background: url(/assets/images/icon/da-icon-active.png) center center/auto no-repeat;
    }
`;

const ReqFormBrTitleLineBlock = styled.div`
    width: 100%;
    height: 1px;
    background-color: #cccccc;
`;

const ReqFormBrListHeaderOpenblock = styled.div`
    ${isMobileOnly?`
    width: 92vw;
    height: 50px;
    top: 0px;
    left: 0vw;
    z-index: -1;
    `:`
    width: 100%;
    height: 50px;
    top: 0px;
    z-index: -1;
    `};
`;

const ReqFormBrListItemTdBlock = styled.div`
    //background-color: rgba(0, 217, 184, 0.1);
    padding: 19px 0 19px;
    vertical-align: middle;
    //border-top: 1px solid #ccc;
    font-size: 15px;
    text-align: center;
    height: 134px;
    //diplay: table;
`;

const ReqFormBrListItemBottomBlock = styled.div`
    position: relative;
    float: left;
    min-width: 150px;
    //min-height: 130px;
    padding: 20px 10px;
    border-radius: 65px;
    //background-color: #e0e0e0;
    text-align: center;
    width: 214px;
    

    &.minus-icon::after {
    top: 46%;
    right: -10px;
    width: 20px;
    height: 20px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 1;
    }

    &.equal-icon::after {
        top: 46%;
        right: -10px;
        width: 20px;
        height: 20px;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        z-index: 1;
      }
`;

const ReqFormBrListItemBottomTitleBlock = styled.div`
    line-height: 1.71;
    display: block;
    margin-bottom: 10px;
    color: #111111;
    font-size: 14px;
    font-weight: normal;
    text-align:center;
    height: 20px;
`;

const ReqFormBrListItemBottomPriceBlock = styled.div`
    ${isMobileOnly?`
    margin-bottom: 10px;
    float: left;
    `:`
    height: 27px;
    line-height: 1.2;
    `};
`;

const ReqFormBrListItemBottomLineBlock = styled.div`
    width: 0;
    height: 55px;
    border-left: solid 1px #cccccc;
    float: left;
    margin-top: 20px;
`;

const MobileReqFormBrListCostContainerBlock = styled.div`
    background-color: #fafafa;
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 20px 20px 20px 0;
`;

const MobileReqFormBrListCostBlock = styled.div`
      float: right;
`;

const MobileReqFormBrListInputBlock = styled.div`
      float: right;
`;

const MobileReqFormBrListLineBlock = styled.div`
    width: 100%;
    height: 2px;
    //margin: 135px 0 0;
    background-color: #111111;
`;

const ReqFormBrList = ({item, handlerBrandChangeQty, handlerDeleteItem, handlerInput, handlerPrice, handleFocus, handleBlur}) => {
    const [open, setOpen] = useState(true);
    const [normalPrice, setNormalPrice] = useState(0);
    const [salePrice, setSalePrice] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const priceRef = useRef(null);

    useEffect(() => {
        let tPrice = 0; //할인된 상품 금액
        let sPrice = 0; //상품 할인 금액
        let nPrice = 0; //정상 상품 가격
        let count = 0;
        if( item !== null && item !== undefined && item.list !== null){


            forEach(item.list, (curobj, index) => {
                let nPrice2 = curobj.prdct_price*1*curobj.qty*1;
                let tPrice2 = curobj.es_opt_pirce*1*curobj.qty*1;
                if(curobj.sale_price === curobj.prdct_price) {
                    nPrice2 = tPrice2;
                }
                nPrice += nPrice2;
                tPrice += tPrice2;
                count++;
            });
        }
        //setCountCheck(count);
        setTotalPrice(tPrice);
        setNormalPrice(nPrice);
        sPrice = nPrice - tPrice;
        setSalePrice(sPrice);

    }, [item])
    
    useEffect(() => {
        if(priceRef !== null && priceRef.current) {
            let inputRef = {brnd_id:item.brnd_id, inputRef: priceRef};
            handlerInput(inputRef);
        }

    }, [priceRef])

    const handleOpen = () => {
        setOpen(!open);
    }

    const handlerChangeQty = (prdct_id, opt_id, value) => {
        if(handlerBrandChangeQty === null || handlerBrandChangeQty === undefined) {
            return;
        }

        handlerBrandChangeQty(item.brnd_id, prdct_id, opt_id, value);
    }

    const handlerDelete = (prdct_id, opt_id) => {
        if(handlerDeleteItem === null || handlerDeleteItem === undefined) {
            return;
        }

        handlerDeleteItem(item.brnd_id, prdct_id, opt_id);
    }


    const handleChangePrice = (value, name) => {
        // console.log("value : " + value + " , name : " + name);
        //setPrice(value);
        handlerPrice(item.brnd_id, value)
    }

    // 패키지 금액 포커서 확인
    const handleChangeCurInputFocus = () => {
        // console.log("handleChangeCurInputFocus")
        //setFocused(true);
        if(handleFocus&&handleFocus!==undefined){
            handleFocus();
        }
    }

    const handleChangeCurInputBlur = () => {
        // console.log("handleChangeCurInputBlur")
        //setFocused(false);
        if(handleBlur&&handleBlur!==undefined){
            handleBlur();
        }
    }

    if(item === null || item === undefined || item.list === null || item.list.length < 1) {
        return <div/>
    }

    return (
        <ReqFormBrListBlock>
            <ReqFormBrListHeaderBlock className="clearfix" onClick={handleOpen}>
                <ReqFormBrListHeaderBrandBlock>{item.list[0].brnd_nm}</ReqFormBrListHeaderBrandBlock>
                <ReqFormBrListHeaderNumBlock>({item.list.length})</ReqFormBrListHeaderNumBlock>
                <ReqFormBrListHeaderArrowSpanBlock className={open? "active":"none"}/>
            </ReqFormBrListHeaderBlock>
            <AnimateHeight duration={300} height={(open ? 'auto' : '0')} className="clearfix">
                {isMobileOnly&&<ReqFormBrTitleLineBlock/>}
            {
                item.list.map((prod, idx) => {
                    return <ReqFormBrListItem key={prod.prdct_id} item={prod} updateCnt={handlerChangeQty} deleteItem={handlerDelete}/>
                })
            }
            {
                isMobileOnly? 
                <MobileReqFormBrListCostContainerBlock className="clearfix">
                    <div className="clearfix">
                    <MobileReqFormBrListCostBlock className="clearfix">
                    <ReqFormBrListItemBottomPriceBlock>
                            {normalPrice*1 === 0 ? 
                            <span style={{ fontSize:"14px", fontWeight:"500"}}>0<span style={{ fontSize:"14px", fontWeight:"normal"}}>원</span></span>
                            :
                            F.showAmount({amount:normalPrice, fontSize:"14px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })
                            }
                        </ReqFormBrListItemBottomPriceBlock>
                        <ReqFormBrListItemBottomPriceBlock><span>&nbsp;-&nbsp;</span></ReqFormBrListItemBottomPriceBlock>
                        <ReqFormBrListItemBottomPriceBlock>
                            {salePrice*1 === 0 ? 
                                <span style={{ fontSize:"14px", fontWeight:"500"}}>0<span style={{ fontSize:"14px", fontWeight:"normal"}}>원</span></span>
                                :
                                F.showAmount({amount:salePrice, fontSize:"14px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })
                            }
                        </ReqFormBrListItemBottomPriceBlock>
                        <ReqFormBrListItemBottomPriceBlock><span>&nbsp;=&nbsp;</span></ReqFormBrListItemBottomPriceBlock>
                        <ReqFormBrListItemBottomPriceBlock>
                            {totalPrice*1 === 0 ? 
                            <span style={{ fontSize:"14px", fontWeight:"600"}}>0<span style={{ fontSize:"14px", fontWeight:"normal"}}>원</span></span>
                            :
                            F.showAmount({amount:totalPrice, fontSize:"14px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })
                            }
                        </ReqFormBrListItemBottomPriceBlock>
                    </MobileReqFormBrListCostBlock>
                    </div>
                    <div className="clearfix">
                    <MobileReqFormBrListInputBlock className="clearfix">
                    
                                <span className="fontsize-12 f-left"
                                    style={{ marginTop: '12px', fontSize:'12px', color: '#333333' }} >
                                    희망 견적 금액
                                </span>
                                <CurrencyInputComp
                                    marginLeft='10px'
                                    width='120px'
                                    height='40px'
                                    float='left'
                                    marginRight='-13px'
                                    placeholder='0'
                                    onChange={handleChangePrice}
                                    onFocus={handleChangeCurInputFocus}
                                    onBlur={handleChangeCurInputBlur}
                                    maxLength='14'
                                    inputRef={priceRef}
                                    textAlign='right'
                                    fontWeight='400'
                                    fontSize='12px'
                                    firstValue={item.price}
                                />
                                
                                <span style={{ position: 'relative', right: '12px', top: '10px',fontSize:'12px' }}>
                                    원
                                </span>
                    </MobileReqFormBrListInputBlock>
                    </div>
                </MobileReqFormBrListCostContainerBlock>
                :
                <ReqFormBrListItemTdBlock  style={{ width: '1176px'}}>
                <div style={{ display: 'flex', justifyContent: 'center', width:'760px', float:'left'}}>

                
                <ReqFormBrListItemBottomBlock className="minus-icon">
                    <ReqFormBrListItemBottomTitleBlock>정상 금액</ReqFormBrListItemBottomTitleBlock>
                    <ReqFormBrListItemBottomPriceBlock>
                        {normalPrice*1 === 0 ? 
                        <span style={{ fontSize:"20px", fontWeight:"500"}}>0<span style={{ fontSize:"18px", fontWeight:"normal"}}>원</span></span>
                        :
                        F.showAmount({amount:normalPrice, fontSize:"20px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"18px" })
                        }
                        
                    </ReqFormBrListItemBottomPriceBlock>
                </ReqFormBrListItemBottomBlock>
                <ReqFormBrListItemBottomBlock className="equal-icon">
                    <ReqFormBrListItemBottomTitleBlock>할인 금액</ReqFormBrListItemBottomTitleBlock>
                    <ReqFormBrListItemBottomPriceBlock>
                    {salePrice*1 === 0 ? 
                        <span style={{ fontSize:"20px", fontWeight:"500"}}>0<span style={{ fontSize:"18px", fontWeight:"normal"}}>원</span></span>
                        :
                        F.showAmount({amount:salePrice, fontSize:"20px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"18px" })
                        }
                    </ReqFormBrListItemBottomPriceBlock>
                </ReqFormBrListItemBottomBlock>
                <ReqFormBrListItemBottomBlock>
                    <ReqFormBrListItemBottomTitleBlock>총 상품 금액</ReqFormBrListItemBottomTitleBlock>
                    <ReqFormBrListItemBottomPriceBlock>
                        {totalPrice*1 === 0 ? 
                        <span style={{ fontSize:"20px", fontWeight:"500"}}>0<span style={{ fontSize:"18px", fontWeight:"normal"}}>원</span></span>
                        :
                        F.showAmount({amount:totalPrice, fontSize:"20px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"18px" })
                        }
                    </ReqFormBrListItemBottomPriceBlock>
                </ReqFormBrListItemBottomBlock>
                </div>
                <div style={{ width: '415px', float:'right'}}>
                <ReqFormBrListItemBottomLineBlock/>
                <div style={{ float: 'right', color:'#333333', marginTop:'27px'}}>

                    <span className="fontsize-15 f-left"
                        style={{ marginTop: '10px' }} >
                        희망 견적 금액
                    </span>

                    <CurrencyInputComp
                        marginLeft='32.5px'
                        width='172px'
                        height='40px'
                        float='left'
                        marginRight='35px'
                        placeholder='0'
                        onChange={handleChangePrice}
                        onFocus={handleChangeCurInputFocus}
                        onBlur={handleChangeCurInputBlur}
                        maxLength='14'
                        inputRef={priceRef}
                        textAlign='right'
                        fontWeight='400'
                        firstValue={item.price}
                    />

                    <span style={{ position: 'relative', right: '65px', top: '9px' }}>
                        원
                    </span>

                </div>
                </div> 
            </ReqFormBrListItemTdBlock>
            }
            </AnimateHeight>
            {isMobileOnly&&<MobileReqFormBrListLineBlock />}
        </ReqFormBrListBlock>
    );
};

export default ReqFormBrList;